import * as React from "react";
const SvgFiRrSortDown = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M12 18a2.67 2.67 0 0 1-1.985-.886l-6.431-6.527c-.602-.658-.746-1.536-.401-2.318A2.1 2.1 0 0 1 5.127 7h13.746c.854 0 1.6.486 1.944 1.269s.2 1.66-.376 2.291l-6.487 6.589A2.65 2.65 0 0 1 12 18M5.127 9c-.026 0-.081 0-.114.074-.033.075.004.116.022.136l6.437 6.534c.204.227.417.256.528.256a.66.66 0 0 0 .497-.222l6.493-6.596s.058.03-.003-.108C18.954 9 18.899 9 18.873 9z"
    />
  </svg>
);
export default SvgFiRrSortDown;
